// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3dcLM","label":"CategoryService_label__-tVwF","location":"CategoryService_location__3hdLY"};